import React from 'react'
import { Image } from 'react-bootstrap';
import MenuIcon from '../../../assets/images/sort.svg';

export interface IconProps {
    width?: string | number;
    height?: string | number;
    className?: string;
}

export default function MenuDotsIcon({
    width = 30,
    height = 30,
    className = '',
}: IconProps) {
    return (
        <Image
            className={`border-0 ps-0 pt-0 ${className}`}
            src={MenuIcon}
            thumbnail={true}
            loading="lazy"
            alt="menu icon"
            width={width}
            height={height}
        />
    )
}